import L from "leaflet";

const userIcon = (driverId, color) => {
	return new L.divIcon({
		iconSize: new L.Point(40, 40),
		iconAnchor: [20, 25],
		tooltipAnchor: [20, -25],
		className: "map-icon",
		html:
			'<div id="marker-driver-' +
			driverId +
			'" style="color: var(--c1)"><svg width="40" height="40" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path fill="none" d="M0 0h24v24H0z"></path> <path d="M17.084 15.812a7 7 0 1 0-10.168 0A5.996 5.996 0 0 1 12 13a5.996 5.996 0 0 1 5.084 2.812zM12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0L12 23.728zM12 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"></path> </g> </g></svg></div>',
	});
};

export { userIcon };
